<div class="ui-form-field profile-picture" [class.is-compact]="compact">

  <label class="ui-label" *ngIf="!compact">{{ label }}</label>

  <div class="profile-pic-wrapper">

    <div class="profile-pic-container" [class.is-disabled]="isDisabled" (click)="openFilePicker()">

      <img [src]="imagePreview" alt="Profile Picture" class="profile-pic" (error)="onImageError()" />

      <div class="profile-pic-loader" *ngIf="isLoading">
        <span class="spinner-border spinner-border-sm"></span>
      </div>

      <!-- Compact: keep the cell clean and only reveal the actions on hover -->
      <div class="profile-pic-hover" *ngIf="compact && !isLoading">

        <button type="button" class="hover-action" *ngIf="hasImage" title="View photo"
          (click)="openPreview(); $event.stopPropagation()">
          <i class="fa-solid fa-eye"></i>
        </button>

        <button type="button" class="hover-action" *ngIf="!isDisabled" title="Upload photo"
          (click)="openFilePicker(); $event.stopPropagation()">
          <i class="fa-solid fa-camera"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Default: actions below the avatar -->
  <div class="profile-pic-actions" *ngIf="!compact">
    <i class="fa-solid fa-eye view-icon" *ngIf="hasImage" title="View photo" (click)="openPreview()"></i>
    <i class="fa-solid fa-upload upload-icon" *ngIf="!isDisabled" title="Upload photo" (click)="openFilePicker()"></i>
    <i class="fa-solid fa-trash-can delete-icon" *ngIf="!isDisabled" title="Remove photo" (click)="deleteImage()"></i>
  </div>

  <input #fileInput type="file" class="d-none" accept="image/*" (change)="onFileSelected($event)" />
</div>

<!-- Full size preview of the uploaded image -->
<div class="profile-pic-lightbox" *ngIf="isPreviewOpen" (click)="closePreview()">

  <div class="lightbox-content" (click)="$event.stopPropagation()">

    <button type="button" class="lightbox-close" title="Close" (click)="closePreview()">
      <i class="fa-solid fa-xmark"></i>
    </button>

    <img [src]="imagePreview" alt="Profile Picture Preview" class="lightbox-image" />

    <button type="button" class="lightbox-remove" *ngIf="!isDisabled" (click)="deleteImage()">
      <i class="fa-solid fa-trash-can"></i>
      Remove photo
    </button>
  </div>
</div>
